import { DateInput, TextInput, required } from 'react-admin';
import { path } from '@/pages/Candidate/constants';
import { StateInput, CountyInput, ProviderInput } from '@/pages/Candidate/view/inputs';
import { DefaultToolbarStyled } from '@/styles/overrides';
import { validateDateBounds } from '@/utils';
import { RequestCountyProps } from '../types';
import useController from './useController';

const FormContent = (props: RequestCountyProps) => {
  const { handleRequest, state } = useController(props);

  return (
    <>
      <TextInput source={path('first_name')} validate={required()} />
      <TextInput source={path('last_name')} validate={required()} />
      <DateInput
        source={path('date_of_birth')}
        label="DOB"
        validate={validateDateBounds({ disableFuture: true, validate: required() })}
      />
      <StateInput label="State" source={path('drivers_license_state')} validate={required()} />
      <CountyInput state={state} validate={required()} />
      <ProviderInput />

      <DefaultToolbarStyled onClose={props.onClose} onSave={handleRequest} saveButtonLabel="Request" />
    </>
  );
};

export default FormContent;
